export default "__VITE_ASSET__jxWnJJKQ__"